// NEW_FILE_JUSTIFIED: Sub-component extracted from ComposeEmail to stay within 200-line limit — renders attachment chips with remove action
import { Button } from '@/components/ui/button';
import { Paperclip, X } from 'lucide-react';
import type { IComposeAttachmentListProps } from '@/@types/gmail';

function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function ComposeAttachmentList({ attachments, onRemove }: IComposeAttachmentListProps) {
  if (attachments.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 pt-2">
      {attachments.map((file, index) => (
        <div
          key={`${file.name}-${index}`}
          className="flex items-center gap-2 rounded-md border border-border bg-muted/50 px-3 py-1.5 text-xs"
        >
          <Paperclip size={12} className="text-muted-foreground" aria-hidden="true" />
          <span className="truncate max-w-[150px]">{file.name}</span>
          <span className="text-muted-foreground">({formatFileSize(file.size)})</span>
          <Button
            variant="ghost"
            size="icon"
            className="ml-1 h-6 w-6 text-muted-foreground hover:text-destructive"
            onClick={() => onRemove(index)}
            aria-label={`Remove ${file.name}`}
          >
            <X size={12} aria-hidden="true" />
          </Button>
        </div>
      ))}
    </div>
  );
}
